// extracted by mini-css-extract-plugin
export default {"addStudentDialog":"addStudentDialog-MM9Oz","title":"title-XnDzN","text":"text-Y53Pi","header":"header-yllfP","closeIcon":"closeIcon-OqmUi","footer":"footer-nUUJy"};